(function () {
  function setupSlider(row) {
    const list = row.querySelector('[data-brand-list]');
    if (!list) return;

    let target = 0;
    let current = 0;
    let rafId = null;

    function runLoop() {
      if (rafId) return;

      const step = () => {
        current += (target - current) * 0.12;
        if (Math.abs(target - current) < 0.5) {
          current = target;
          list.scrollLeft = current;
          rafId = null;
          return;
        }
        list.scrollLeft = current;
        rafId = requestAnimationFrame(step);
      };
      rafId = requestAnimationFrame(step);
    }

    row.addEventListener('mousemove', (event) => {
      const maxScroll = list.scrollWidth - list.clientWidth;
      if (maxScroll <= 0) return;

      const rect = row.getBoundingClientRect();
      const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
      target = ratio * maxScroll;
      runLoop();
    });

    row.addEventListener('mouseleave', () => {
      target = 0;
      runLoop();
    });
  }

  document.querySelectorAll('[data-brand-slider]').forEach(setupSlider);
})();
